
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import {
  getNotifications,
  clearNotifications,
  markAllAsRead,
} from "./notificationsStore";

export default function AdminNotifications() {
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("membreToken");

    if (!token) {
      navigate("/login");
      return;
    }

    try {
      const decoded = jwtDecode(token);

      if (decoded.role !== "admin") {
        localStorage.removeItem("membreToken");
        navigate("/login");
        return;
      }

      
      markAllAsRead();
      setNotifications(getNotifications());

    } catch (err) {
      console.error("Token invalide");
      localStorage.removeItem("membreToken");
      navigate("/login");
    }
  }, [navigate]);

  return (
    <div className="p-4">
      <div className="bg-white dark:bg-gray-900 p-5 rounded-lg shadow max-w-xl mx-auto">
        <h1 className="text-xl sm:text-2xl mb-5 font-bold dark:text-white">
          Notifications
        </h1>

        {notifications.length === 0 ? (
          <p className="text-gray-500 dark:text-gray-400">
            Aucune notification.
          </p>
        ) : (
          <ul className="space-y-3">
            {notifications.map((n) => (
              <li
                key={n.id}
                className="p-3 bg-gray-100 dark:bg-gray-800 rounded"
              >
                <p className="font-medium dark:text-white">{n.text}</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {n.date}
                </p>
              </li>
            ))}
          </ul>
        )}

        <button
          onClick={() => {
            clearNotifications();
            setNotifications([]);
          }}
          className="mt-4 px-4 py-2 bg-red-600 text-white rounded w-full sm:w-auto"
        >
          Tout supprimer
        </button>
      </div>
    </div>
  );
}
